import { useState } from 'react';

interface HeaderProps {
  keyword: string;
  setKeyword: (v: string) => void;
  menu: boolean;
  setMenu: (v: boolean) => void;
}

export default function Header({ keyword, setKeyword, menu, setMenu }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#030712]/80 border-b border-white/5">
      <div className="max-w-[1800px] mx-auto px-6 md:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img
            src="https://static.readdy.ai/image/9e747d83165d349a03f5427ea4fab807/ff89e372032fff0d5aff6b38fd727991.png"
            alt="陆渔科技"
            className="h-10 w-auto"
          />
          <div className="hidden md:block">
            <span className="text-lg font-bold bg-gradient-to-r from-[#00D4FF] to-[#00FFA3] bg-clip-text text-transparent">
              确定性农业产品矩阵
            </span>
          </div>
        </div>

        {/* 搜索框 */}
        <div className="flex-1 max-w-md mx-4 md:mx-8">
          <div className="relative group">
            <input
              type="text"
              placeholder="搜索产品..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              className="w-full px-5 py-2.5 bg-white/5 border border-white/10 rounded-full text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#00D4FF]/50 focus:bg-white/10 transition-all duration-300"
            />
            <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-white/40 group-focus-within:text-[#00D4FF]"></i>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://luyuaqua.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-block px-5 py-2 bg-gradient-to-r from-[#00D4FF]/20 to-[#00FFA3]/20 border border-[#00D4FF]/30 rounded-full text-sm font-medium hover:border-[#00D4FF] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            访问官网
          </a>
          {/* 移动端菜单按钮 */}
          <button
            className="md:hidden text-white/70 hover:text-white text-2xl cursor-pointer"
            onClick={() => setMenu(!menu)}
          >
            <i className={menu ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>
    </header>
  );
}